/**
 * Integrytas Group — ContentCard (common).
 *
 * The single elevated card of the Direction-D page skeleton: white, 10px
 * radius, 1px #D3DAE3 border, one soft shadow (design/desktop/README.md). For a
 * list page it wraps the toolbar, grid header, rows and footer FLUSH (no inner
 * padding, so the grid meets the card edge and its corners clip to the radius);
 * for a form/detail card pass `padded` for the standard 18px inset.
 *
 *   <ContentCard>            — list: toolbar + grid + footer (flush)
 *   <ContentCard padded>     — form/detail (18px inset)
 *
 * Distinct from <Card> (the `.csm-card` boxed section with its own title +
 * padding); ContentCard is the outer page card.
 */

import type { ReactNode } from 'react';

interface ContentCardProps {
  children: ReactNode;
  /** Add the standard 18px inner padding (forms/detail). Omit for list cards. */
  padded?: boolean;
  className?: string;
}

export function ContentCard({ children, padded = false, className = '' }: ContentCardProps) {
  return (
    <div
      className={
        'overflow-hidden rounded-csm-card border border-csm-line bg-white shadow-csm-card ' +
        (padded ? 'p-[18px] ' : '') +
        className
      }
    >
      {children}
    </div>
  );
}
